import type { TrackingEvent } from '../../types';

interface FacebookEventData {
    eventName: string;
    type: 'standard' | 'custom';
}

export function getFacebookEvent(
    event: TrackingEvent,
): FacebookEventData | null {
    let facebookEvent: string | null = null;

    let isStandardEvent = false;

    switch (event) {
        // Page Views
        case 'PageView':
            facebookEvent = 'PageView';
            isStandardEvent = true;
            break;
        case 'ViewProduct':
            facebookEvent = 'ViewContent';
            isStandardEvent = true;
            break;
        case 'PerformSearch':
            facebookEvent = 'Search';
            isStandardEvent = true;
            break;

        // Conversions
        case 'DownloadsClick':
        case 'DownloadsLoggedOutClick':
            facebookEvent = 'FileDownload';
            break;
        case 'EnquiryReveal':
            facebookEvent = 'EnquiryReveal';
            break;
        case 'EnquiryEngagement':
            facebookEvent = 'EnquiryEngagement';
            break;
        // Reported on successful enquiry creation rather than on submit
        // attempt, so the browser pixel and the server-side Conversions API
        // copy describe the same conversion and deduplicate against each other.
        // Failed attempts are deliberately not reported to Meta.
        case 'CreatedEnquiry':
            facebookEvent = 'EnquirySubmit';
            break;
        case 'Website':
            facebookEvent = 'WebsiteReferral';
            break;
        case 'TargetedWebsite':
            facebookEvent = 'Targeted_WebsiteReferral';
            break;
        case 'SaveSubmit':
            facebookEvent = 'Save';
            break;
        case 'PhoneReveal':
            facebookEvent = 'PhoneReveal';
            break;
        case 'BookConsultationReveal':
            facebookEvent = 'BookConsultationReveal';
            break;
        case 'HDESubmission':
            facebookEvent = 'HDESubmission';
            break;

        // Ecom
        case 'AddToCart':
            facebookEvent = 'AddToCart';
            isStandardEvent = true;
            break;
        case 'InitiateCheckout':
            facebookEvent = 'InitiateCheckout';
            isStandardEvent = true;
            break;
        case 'Purchase':
            facebookEvent = 'Purchase';
            isStandardEvent = true;
            break;
    }

    if (!facebookEvent) {
        return null;
    }

    return {
        eventName: facebookEvent,
        type: isStandardEvent ? 'standard' : 'custom',
    };
}
